import React, {useEffect, useId, useState} from 'react';
import {Link, useParams} from "react-router";
import ToggleDropdown from '../reused-components/SidebarTabs';
import AddProducts from '../reused-components/AddProducts';
import Profile from '../reused-components/Profile';
import UserBlocks from "../reused-components/UserBlocks";
import ReportRange from "../reused-components/RangeDatePicker";
import smlogo from '../../img/sm-logo.svg';
import profileImage from '../../img/user-profile.png';
import userIcon from '../../img/user.svg';
import gearIcon from '../../img/gear-icon.svg';
import installIcon from '../../img/installation-icon.svg';
import VersionsStackedAreaChart from "../reused-components/Charts/VersionsStackedAreaChart";
import StackedAreaChart from "../reused-components/Charts/LangLocaleStackedAreaChart";
import UninstallReasonsPieChart from "../reused-components/Charts/UninstallReasonsPieChart";
import TrendlineChart from "../reused-components/Charts/EffectiveGrowthTrendLineChart";
import AudienceActivitiesMixChart from "../reused-components/Charts/AudienceActivitiesMixChart";
import {fetchDashboardStats} from "../../services/apiService";
import moment from 'moment';
import GroupByDropdown from "../reused-components/GroupByDropdown";
import {getDefaultGroupByValue} from "../../utils/dataProcessing";
import DarkModeSwitch from "../reused-components/ToggleDarkMode";
// import {useTelemetryContext} from "../../contexts/TelemetryContext"; // Assuming you have moment.js installed

export default function Login() {
    document.title = "Dashboard | Telemetry";

    // Initialize the dates
    const [startDate, setStartDate] = useState(moment().subtract(90, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss')); // 90 days ago
    const [endDate, setEndDate] = useState(moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')); // today
    const [compareStartDate, setCompareStartDate] = useState(''); // 90 days ago
    const [compareEndDate, setCompareEndDate] = useState(''); // today

    const [filterGroupBy, setFilterGroupBy] = useState('month'); // Default to 'month'
    const [userStats, setUserStats] = useState('');
    const [showGrowth, setShowGrowth] = useState(false);
    const [showComparisonDateRange, setShowComparisonDateRange] = useState(false);
    // const {selectedProduct} = useTelemetryContext();
    const { storeId, productId } = useParams();
    const compareToggleId = useId();

    const handleDateChange = (start, end) => {
        // Set start date to the start of the day
        const startOfDay = moment(start).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        // Set end date to the end of the day
        const endOfDay = moment(end).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        setStartDate(startOfDay);
        setEndDate(endOfDay);
    };


    const handleCompareDateChange = (start, end) => {
        // Set start date to the start of the day
        setShowGrowth(true);
        const startOfDay = moment(start).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        // Set end date to the end of the day
        const endOfDay = moment(end).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        setCompareStartDate(startOfDay);
        setCompareEndDate(endOfDay);
    };

    useEffect(() => {
        const defaultGroupBy = getDefaultGroupByValue(startDate, endDate);
        setFilterGroupBy(defaultGroupBy);
    }, [startDate, endDate]);


    const handleGroupByDropdownClick = (groupBy) => {
        setFilterGroupBy(groupBy);
    }

    const handleCompareToChange = () => {
        if (showComparisonDateRange) {
            setShowComparisonDateRange(false);
            setCompareStartDate('');
            setCompareEndDate('');
            setShowGrowth(false);
        } else {
            setShowComparisonDateRange(true);
        }
    }

    useEffect(() => {
        setUserStats({
            all_time_users: '-',
            all_time_installs: '-',
            activations: '-',
            deactivations: '-',
            uninstalls: '-',
        });
        const fetchData = async () => {
            try {
                const responseData = await fetchDashboardStats(productId);
                setUserStats({
                    all_time_users: responseData.all_time_users.toLocaleString(),
                    all_time_installs: responseData.all_time_installs.toLocaleString(),
                    activations: responseData.activations.toLocaleString(),
                    deactivations: responseData.deactivations.toLocaleString(),
                    uninstalls: responseData.uninstalls.toLocaleString(),
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [productId]);

    useEffect(() => {
        const savedDates = ['startDate', 'endDate', 'compareStartDate', 'compareEndDate', 'showComparisonDateRange'].reduce((acc, key) => {
            acc[key] = localStorage.getItem(key);
            return acc;
        }, {});

        if (savedDates.startDate) setStartDate(savedDates.startDate);
        if (savedDates.endDate) setEndDate(savedDates.endDate);
        if (savedDates.compareStartDate) setCompareStartDate(savedDates.compareStartDate);
        if (savedDates.compareEndDate) setCompareEndDate(savedDates.compareEndDate);
        setShowComparisonDateRange(savedDates.showComparisonDateRange === 'true');

        if (savedDates.compareStartDate && savedDates.compareEndDate) {
            setShowGrowth(true);
        }
    }, []);

    useEffect(() => {
        if (compareStartDate && compareEndDate) {
            setShowGrowth(true);
        }
    }, [compareStartDate, compareEndDate]);

    useEffect(() => {
        const dates = { startDate, endDate, compareStartDate, compareEndDate, showComparisonDateRange };
        Object.keys(dates).forEach(key => localStorage.setItem(key, dates[key]));
    }, [startDate, endDate, compareStartDate, compareEndDate, showComparisonDateRange]);

    return (
        <div className="telemetry-page-wrapper">
            <header className="telemetry-header">
                <div className="telemetry-logo-section">
                    <Link to={`/stores/${storeId}/plugins/${productId}/dashboard`}>
                        <img src={smlogo} alt="Telemetry"/>
                    </Link>
                </div>
                <div className="telemetry-top">
                    <h1>Product Dashboard</h1>
                    <div className="telemetry-top-right">
                    <DarkModeSwitch />
                        <AddProducts/>
                        <Profile image={profileImage}/>
                    </div>
                </div>
            </header>
            <main className="telemetry-main">
                <aside className="telemetry-sidebar">
                    <ToggleDropdown tabactive={1} tabactive2={1}/>
                </aside>
                <section className="telemetry-content">
                    <div className="telemetry-user-block">
                        <UserBlocks
                            img={userIcon}
                            wrapper="telemetry-user-block-orange"
                            inner="telemetry-orange"
                            number={userStats?.all_time_users}
                            userText="All-time Users"
                            tooltip="User info"
                        />
                        <UserBlocks
                            img={gearIcon}
                            wrapper="telemetry-user-block-green"
                            inner="telemetry-green"
                            number={userStats?.activations}
                            userText="Active Install"
                            tooltip="User info"
                            up={`${userStats?.deactivations} Deactivations`}
                            down={`${userStats?.uninstalls} Uninstalls`}
                        />
                        <UserBlocks
                            img={installIcon}
                            wrapper="telemetry-user-block-blue"
                            inner="telemetry-blue"
                            number={userStats?.all_time_installs}
                            userText="All-time Installs"
                            tooltip="User info"
                        />
                    </div>
                    <div className="telemetry-block-section">
                        <h2>Uninstall Reasons %</h2>
                        {productId ? (
                            <UninstallReasonsPieChart
                                productId={productId}
                                // title="Uninstall Reasons %"
                                meta_key="uninstall-reasons"
                                group_by_period={filterGroupBy}
                                start_date={startDate}
                                end_date={endDate}
                            />
                        ) : (
                            <p>Loading chart...</p>
                        )}
                    </div>
                    <div className="telemetry-filter">
                        <ReportRange
                            label="Current period"
                            onChange={handleDateChange}
                            startDate={startDate}
                            endDate={endDate}
                        />
                        <div className="telemetry-compare-toggle">
                            <label className="telemetry-checkbox-label" htmlFor={compareToggleId}>
                                <input
                                    id={compareToggleId}
                                    type="checkbox"
                                    checked={showComparisonDateRange}
                                    onChange={handleCompareToChange}
                                />
                                Compared to
                            </label>
                        </div>

                        {showComparisonDateRange && (
                            <ReportRange
                                label="Comparison period"
                                onChange={handleCompareDateChange}
                                startDate={compareStartDate}
                                endDate={compareEndDate}
                            />
                        )}

                        <GroupByDropdown
                            handleGroupByDropdownClick={handleGroupByDropdownClick}
                            startDate={startDate}
                            endDate={endDate}
                            group_by_period={filterGroupBy}
                        />
                    </div>

                    <div className="telemetry-block-section">
                        <h2>Effective Growth</h2>
                        {productId ? (
                            <TrendlineChart
                                product_id={productId}
                                title="Growth"
                                meta_key="effective-growth"
                                group_by_period={filterGroupBy}
                                start_date={startDate}
                                end_date={endDate}
                                compare_start_date={compareStartDate}
                                compare_end_date={compareEndDate}
                                showGrowth={showGrowth}
                            />
                        ) : (
                            <p>Loading chart...</p>
                        )}
                    </div>
                    <div className="telemetry-block-section">
                        <h2>Audience Activities</h2>
                        {productId ? (
                            <AudienceActivitiesMixChart
                                product_id={productId}
                                title="Audience Activities"
                                meta_key="audience-activities"
                                group_by_period={filterGroupBy}
                                start_date={startDate}
                                end_date={endDate}
                            />
                        ) : (
                            <p>Loading chart...</p>
                        )}
                    </div>
                    <div className="telemetry-block-section">
                        <h2>Version Breakdowns</h2>
                        {productId ? (
                            <VersionsStackedAreaChart
                                product_id={productId}
                                title="Plugin Versions"
                                meta_key="site-meta/version"
                                group_by_period={filterGroupBy}
                                start_date={startDate}
                                end_date={endDate}
                                compare_start_date={compareStartDate}
                                compare_end_date={compareEndDate}
                                showGrowth={showGrowth}
                            />
                        ) : (
                            <p>Loading chart...</p>
                        )}
                        {productId ? (
                            <VersionsStackedAreaChart
                                product_id={productId}
                                title="WP Versions"
                                meta_key="site-meta/wp_version"
                                group_by_period={filterGroupBy}
                                start_date={startDate}
                                end_date={endDate}
                                compare_start_date={compareStartDate}
                                compare_end_date={compareEndDate}
                                showGrowth={showGrowth}
                            />
                        ) : (
                            <p>Loading chart...</p>
                        )}
                        {productId ? (
                            <VersionsStackedAreaChart
                                product_id={productId}
                                title="PHP Versions"
                                meta_key="site-meta/php_version"
                                group_by_period={filterGroupBy}
                                start_date={startDate}
                                end_date={endDate}
                                compare_start_date={compareStartDate}
                                compare_end_date={compareEndDate}
                                showGrowth={showGrowth}
                            />
                        ) : (
                            <p>Loading chart...</p>
                        )}
                        {productId ? (
                            <VersionsStackedAreaChart
                                product_id={productId}
                                title="SDK Versions"
                                meta_key="site-meta/sdk_version"
                                group_by_period={filterGroupBy}
                                start_date={startDate}
                                end_date={endDate}
                                compare_start_date={compareStartDate}
                                compare_end_date={compareEndDate}
                                showGrowth={showGrowth}
                            />
                        ) : (
                            <p>Loading chart...</p>
                        )}
                    </div>
                    <div className="telemetry-block-section">
                        <h2>Location & Language </h2>
                        {productId ? (
                            <StackedAreaChart
                                product_id={productId}
                                title="Countries"
                                meta_key="site-meta/wp_location"
                                group_by_period={filterGroupBy}
                                start_date={startDate}
                                end_date={endDate}
                                compare_start_date={compareStartDate}
                                compare_end_date={compareEndDate}
                                showGrowth={showGrowth}
                            />
                        ) : (
                            <p>Loading chart...</p>
                        )}
                        {productId ? (
                            <StackedAreaChart
                                product_id={productId}
                                title="Languages"
                                meta_key="site-meta/wp_locale"
                                group_by_period={filterGroupBy}
                                start_date={startDate}
                                end_date={endDate}
                                compare_start_date={compareStartDate}
                                compare_end_date={compareEndDate}
                                showGrowth={showGrowth}
                            />
                        ) : (
                            <p>Loading chart...</p>
                        )}
                    </div>
                </section>
            </main>
        </div>
    );
}
